/**
 * Horizontal inset for ClientHeader only (left-biased; not used by page content).
 * Matches Figma Desktop - 1 header at x=156 on large screens.
 */
export const CLIENT_HEADER_INSET_X =
  "px-4 sm:px-8 md:pl-12 lg:pl-[156px]" as const;
